import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import classnames from 'classnames';

import styles from './link.scss';

const Link = ({ children, className, linkTo, color, amplified }) => {
  const linkClass = classnames(styles.link, className, { [styles[color]]: color, [styles.amplified]: amplified });

  return (
    <RouterLink className={linkClass} to={linkTo}>{children}</RouterLink>
  )
};

Link.propTypes = {
  text: PropTypes.string,
  linkTo: PropTypes.string,
  color: PropTypes.string,
  amplified: PropTypes.bool,
  className: PropTypes.string,
};

Link.defaultProps = {
  color: "gray",
  amplified: false,
};

export { Link };



// WEBPACK FOOTER //
// ./src/elements/link/link.js